<template>
	<div class="webview-pain-type-ai">
		<sorry-page v-if="isError" @reload="getData" class="webview-pain-type-ai__inner" />
		<v-ons-page v-else-if="isMount" class="webview-pain-type-ai__inner">
			<pain-type-ai-result />
		</v-ons-page>
	</div>
</template>

<script>
// Vuex
import { mapActions } from 'vuex'
import { SET_USER_ID, SET_USER_TOKEN, SET_IS_WEBVIEW, SET_PREMIUM_TYPE } from '../store/modules/common/mutation-types'
import { SET_RESULT_OF_ANALYSIS_DATA } from '../store/modules/ai/mutation-types'

// ライブラリ
import cmnConst from '@/assets/js/constant.js'

// Compornents
import PainTypeAiResult from '@/components/Organisms/PainTypeAiResult'
import SorryPage from '@/views/SorryPage'

export default {
	name: 'WebviewPainTypeAiResult',
	components: {
		PainTypeAiResult,
		SorryPage
	},
	data () {
		return {
			isError: false,
			isMount: false,
			userId: null,
			userToken: null,
			html: null
		}
	},
	created () {
		// 横幅に合わせてフォントサイズや余白をレスポンシブに可変する対応
		// TODO: common.scssでルートフォントをvwで指定するようにしたい。もしできたらこちらの処理は不要なので削除。
		const propWidth = document.body.offsetWidth
		const style = propWidth <= 640 ? 'font-size: 16px; font-size: 5vw;' : 'font-size: 27px;'
		this.html = document.getElementsByTagName('html')[0]
		this.html.setAttribute('style', style)

		this.SET_IS_WEBVIEW(true)

		// URLパラメータをチェック
		const state = this.$route.query.state ? this.$route.query.state.toString() : ''
		const stateArray = state.split(cmnConst.SEPARATOR)
		if (state === 'error' || state === '') {
			// 認証エラー
			console.log('state error: ', state)
			this.isError = true
		} else if (stateArray.length !== 2) {
			// 認証パラメータエラー
			console.log('state length error: ', this.$route.query)
			this.isError = true
		} else {
			// URLパラメータからユーザーID、ユーザートークン、記録回数を取得する
			this.userId = stateArray[0]
			this.userToken = stateArray[1]
			this.SET_USER_ID(this.userId)
			this.SET_USER_TOKEN(this.userToken)

			// 分析結果取得
			this.getData()
		}
	},
	mounted () {
	},
	computed: {
	},
	methods: {
		// map Vuex actions
		...mapActions('common', [SET_USER_ID, SET_USER_TOKEN, SET_IS_WEBVIEW, SET_PREMIUM_TYPE]),
		...mapActions('ai', [SET_RESULT_OF_ANALYSIS_DATA]),

		// 分析結果取得
		getData () {
			// APIリクエスト処理
			const SET_PREMIUM_TYPE = this.SET_PREMIUM_TYPE({
				user_id: this.userId,
				user_token: this.userToken
			})
			const SET_RESULT_OF_ANALYSIS_DATA = this.SET_RESULT_OF_ANALYSIS_DATA({
				user_id: this.userId,
				user_token: this.userToken
			})
			Promise.all([SET_PREMIUM_TYPE, SET_RESULT_OF_ANALYSIS_DATA]).then(res => {
				this.isMount = true
			}).catch(error => {
				console.log('Error: ', error)
				this.isError = true
			})
		}
	},
	beforeDestroy () {
		this.html.removeAttribute('style')
	}
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/variable";

.webview-pain-type-ai {
	width: 100%;
	height: 100%;
}
</style>
